var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 743,
    height: 464,
    viewBox: "0 0 743 464",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-93 470c253.5-15.167 784.6-159.5 881-615.5",
    stroke: "#20FFC3",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.311,
    strokeDasharray: "0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBg1);
export default __webpack_public_path__ + "static/media/imgBg1.9d85c5013f9ecf5a3c49e0d33402992e.svg";
export { ForwardRef as ReactComponent };